const tags = ["Joplin, MO", "Hoosier at Heart", "Tech Enthusiast", "Person of Faith", "Podcast Host"];

export default function HostBio() {
  return (
    <section
      className="py-24 lg:py-32"
      style={{ background: "linear-gradient(180deg, #fffbf5 0%, #fef3c7 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Section label */}
        <div className="text-center mb-16">
          <span className="font-sans text-xs font-semibold tracking-widest uppercase text-amber-600 block mb-3">
            Meet Your Host
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-amber-900 leading-tight">
            About Your Host
          </h2>
        </div>

        {/* Two-column: text left, photo right */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">

          {/* Left — bio text */}
          <div className="lg:col-span-7 space-y-6">

            {/* Personal greeting */}
            <div className="bg-white rounded-2xl px-8 py-7 border border-amber-100">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-100 flex-shrink-0">
                  <i className="ri-user-smile-line text-amber-700 text-xl" />
                </div>
                <div>
                  <p className="font-sans font-bold text-amber-900 text-base">Rich Thurman</p>
                  <p className="font-sans text-xs text-stone-400 tracking-wide">Host &amp; Creator · Joplin, MO</p>
                </div>
              </div>
              <p className="font-sans text-base text-stone-600 leading-relaxed">
                Hi, my name is Rich Thurman. I&apos;m a down-to-earth guy that lives in Joplin, MO, with my wonderful fiancée Kim Skaggs. I grew up in Huntington, Indiana — so I guess I&apos;m a Hoosier at heart.
              </p>
            </div>

            {/* Why he started it */}
            <div className="space-y-5 font-sans text-base text-stone-600 leading-relaxed">
              <p>
                I started this podcast because I love technology, and AI is at the forefront of a tsunami of change that&apos;s happening right now. I genuinely believe <strong className="text-amber-900">AI will be bigger than the introduction of smartphones and the internet combined.</strong>
              </p>
              <p>
                I have a compassion and heart for people — rooted deep in my Christian faith. I wanted to make this podcast to inform and encourage everyday people to get educated about AI and how it can impact your life in a positive way.
              </p>
              <p>
                Thank you for stopping by and showing an interest. My agenda is simple, transparent, and honest. Let&apos;s have fun on this journey together.
              </p>
            </div>

            {/* Closing sign-off */}
            <div className="border-l-4 border-amber-400 pl-6">
              <p className="font-serif italic text-amber-800 text-lg leading-relaxed">
                "Take care and God Bless."
              </p>
              <p className="font-sans text-sm font-semibold text-amber-700 mt-2">— Rich Thurman</p>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 pt-2">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="font-sans text-xs font-medium bg-amber-100 text-amber-800 rounded-full px-4 py-1.5"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right — host photo placeholder */}
          <div className="lg:col-span-5">
            <div className="relative">
              {/* Photo container */}
              <div
                className="w-full rounded-3xl overflow-hidden border-4 border-amber-200"
                style={{ height: "520px" }}
              >
                <img
                  src="https://static.readdy.ai/image/f9f32838a9120faa908a5852ba765d83/50f356d8442efeaffa4aece5ed7c972a.jpeg"
                  alt="Rich Thurman — Host of The Humble Machine"
                  className="w-full h-full object-cover object-top"
                />
                {/* Placeholder overlay hint */}
                <div className="absolute inset-0 flex flex-col items-center justify-end pb-6 pointer-events-none">
                  <div className="bg-black/40 backdrop-blur-sm rounded-xl px-5 py-3 text-center mx-6">
                    <p className="font-sans text-xs text-white/80">
                      📸 Your photo will go here — just send it over!
                    </p>
                  </div>
                </div>
              </div>

              {/* Floating quote card */}
              <div className="absolute -bottom-6 -left-6 bg-amber-700 rounded-2xl p-5 max-w-[220px]">
                <i className="ri-double-quotes-l text-amber-300 text-xl mb-2 block" />
                <p className="font-serif italic text-amber-50 text-sm leading-relaxed">
                  "Let&apos;s have fun on this journey together."
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
